'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactSortableHoc = require('react-sortable-hoc');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _containers = require('containers');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Sortable.scss');


var sortboxOuter = 'sortbox sortboxOuter ' + styles.sortbox;
var sortboxInner = 'sortbox sortboxInner ' + styles.sortbox;
var icon_wrapper = 'icon_wrapper ' + styles.icon_wrapper;
var moveHandle = 'glyphicon glyphicon-move ' + styles.movehandle;
var moveHandleOuter = 'glyphicon glyphicon-move ' + styles.movehandleout;
var addIconClass = 'glyphicon glyphicon-plus ' + styles.hideicons + ' ' + styles.hideiconsplus;
var deleteIconClass = 'glyphicon glyphicon-trash ' + styles.hideicons + ' ' + styles.hideiconstrash;
var moveUpOuter = 'glyphicon glyphicon-arrow-up arrow-out ' + styles.movehandleupout;
var moveDownOuter = 'glyphicon glyphicon-arrow-down arrow-out ' + styles.movehandledownout;

var DragHandleInner = new _reactSortableHoc.SortableHandle(function () {
  return _react2.default.createElement('span', { style: { color: 'black' }, className: moveHandle });
});
var DragHandle = new _reactSortableHoc.SortableHandle(function () {
  return _react2.default.createElement('span', { className: moveHandleOuter });
});

var sortableItemParent = 'complete-section-wrapper sortable-item-parent ' + styles.sortableItemParent;

// ivalue is passed by parent to get the index of the elemnt clicked on.
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var value = _ref.value,
      ivalue = _ref.ivalue,
      moveUp = _ref.moveUp,
      moveDown = _ref.moveDown,
      addClick = _ref.addClick,
      deleteClick = _ref.deleteClick,
      data_parent = _ref.data_parent,
      children = _ref.children,
      dataOrder = _ref.dataOrder,
      dataStyleClass = _ref.dataStyleClass,
      dataSectionStyleClass = _ref.dataSectionStyleClass,
      dataAspectRatio = _ref.dataAspectRatio,
      dataBlockClass = _ref.dataBlockClass;

  if (children) {
    return _react2.default.createElement(
      'div',
      { className: sortboxOuter },
      _react2.default.createElement(DragHandle, null),
      _react2.default.createElement('span', { className: moveUpOuter, onClick: function onClick() {
          return moveDown(ivalue);
        } }),
      _react2.default.createElement('span', { className: moveDownOuter, onClick: function onClick() {
          return moveUp(ivalue);
        } }),
      value
    );
  } else {
    return _react2.default.createElement(
      'div',
      { className: sortboxInner },
      _react2.default.createElement(
        'div',
        { className: icon_wrapper },
        _react2.default.createElement(DragHandleInner, null),
        _react2.default.createElement('span', { className: addIconClass,
          onClick: function onClick() {
            return addClick(ivalue);
          } }),
        _react2.default.createElement('span', { style: { marginLeft: 10, marginRight: 10 },
          className: deleteIconClass,
          onClick: function onClick() {
            return deleteClick(ivalue);
          } })
      ),
      _react2.default.createElement(
        'div',
        { className: data_parent + '-child-' + ivalue + ' section-child', id: data_parent + '-child-' + ivalue },
        _react2.default.createElement(_containers.DataBox, {
          data_parent: data_parent,
          data_id: ivalue,
          dataOrder: dataOrder,
          dataStyleClass: dataStyleClass,
          dataSectionStyleClass: dataSectionStyleClass,
          dataAspectRatio: dataAspectRatio,
          dataBlockClass: dataBlockClass
        })
      )
    );
  }
});

// Here ivalue is passed ahead so that addbtn and deletebtn
// work using their indx value
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var items = _ref2.items,
      moveUp = _ref2.moveUp,
      moveDown = _ref2.moveDown,
      addClick = _ref2.addClick,
      deleteClick = _ref2.deleteClick,
      data_parent = _ref2.data_parent,
      children = _ref2.children,
      dataOrder = _ref2.dataOrder,
      dataStyleClass = _ref2.dataStyleClass,
      dataSectionStyleClass = _ref2.dataSectionStyleClass,
      dataAspectRatio = _ref2.dataAspectRatio,
      dataBlockClass = _ref2.dataBlockClass;

  if (children) {
    return _react2.default.createElement(
      'div',
      { className: data_parent + ' sortable-item-parent' },
      items.map(function (value, index) {
        return _react2.default.createElement(SortableItem, {
          key: value.props.dataParent,
          index: index,
          value: value,
          moveUp: moveUp,
          moveDown: moveDown,
          addClick: addClick,
          deleteClick: deleteClick,
          ivalue: index,
          data_parent: data_parent,
          children: children,
          dataOrder: dataOrder,
          dataStyleClass: dataStyleClass,
          dataSectionStyleClass: dataSectionStyleClass,
          dataAspectRatio: dataAspectRatio,
          dataBlockClass: dataBlockClass
        });
      })
    );
  } else {
    return _react2.default.createElement(
      'div',
      { className: data_parent + ' sortable-item-parent' },
      items.map(function (value, index) {
        return _react2.default.createElement(SortableItem, {
          key: value.id,
          index: index,
          value: value,
          moveUp: moveUp,
          moveDown: moveDown,
          addClick: addClick,
          deleteClick: deleteClick,
          ivalue: index,
          data_parent: data_parent,
          children: children,
          dataOrder: dataOrder,
          dataStyleClass: dataStyleClass,
          dataSectionStyleClass: dataSectionStyleClass,
          dataAspectRatio: dataAspectRatio,
          dataBlockClass: dataBlockClass
        });
      })
    );
  }
});

var Sortable = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    // templateData: state.templateData,
    personal_info: state.templateData.personal_info,
    info_block: state.templateData.info_block,
    inter_section_margin: state.templateData.inter_section_margin,
    design_template_name: state.templateData.design_template_name,
    content_template_name: state.templateData.content_template_name,
    design_order: state.templateData.design_order,
    ReactGA: state.company.ReactGA,
    analysis_mode_on: state.templateData.analysis_mode_on
  };
}, {
  pushState: _reactRouterRedux.push,
  sort: templateData.sort,
  delete: templateData.deleteBlock,
  copy: templateData.copyBlock,
  sortDataOrder: templateData.sortDataOrder,
  setDesingOrder: templateData.setDesingOrder
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Sortable, _Component);

  function Sortable(props) {
    (0, _classCallCheck3.default)(this, Sortable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Sortable.__proto__ || (0, _getPrototypeOf2.default)(Sortable)).call(this, props));

    _this.onSortEnd = function (_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;

      _this.clearClass('section-menu-item-wrapper');
      if (_this.state.children) {
        _this.setState({
          items: (0, _reactSortableHoc.arrayMove)(_this.state.items, oldIndex, newIndex)
        });
        _this.props.sortDataOrder(oldIndex, newIndex);
      } else {
        _this.setState({
          items: (0, _reactSortableHoc.arrayMove)(_this.state.items, oldIndex, newIndex)
        });
        // console.log(this.state);
        // console.log(this.props);
        // if(this.state.data_parent === 'professional'){
        //   this.props.sortProfessional(oldIndex, newIndex);
        // }
        // if(this.state.data_parent === 'miscellaneous'){
        //   this.props.sortMiscellaneous(oldIndex, newIndex);
        // }
        _this.props.sort(oldIndex, newIndex, _this.state.data_parent);
      }
    };

    _this.clearClass = function (classToClear) {
      var elems = document.getElementsByClassName(classToClear);
      if (elems.length >= 1) {
        for (var k = elems.length - 1; k >= 0; k--) {
          var parent = elems[k].parentNode;
          parent.removeChild(elems[k]);
        }
      }
    };

    _this.state = {
      items: false,
      data_parent: _this.props.dataParent,
      children: _this.props.child,
      dataStyleClass: _this.props.dataStyleClass,
      dataSectionStyleClass: _this.props.dataSectionStyleClass,
      dataOrder: _this.props.dataOrder,
      section_analysis_visible: false
    };
    return _this;
  }

  (0, _createClass3.default)(Sortable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var newState = [];
      var remainigState = [];
      var design_order = [];
      if (this.state.children) {
        // console.log(this.state.children);
        // console.log(this.state.children);
        // console.log(this.props.children);
        // Add in order of dataOrder only if dataOrder exists.
        // IF dataOrder is null add in default order
        // This would eliminate the need of adding order in each desing template.
        if (this.props.design_order) {
          // console.log(this.props.design_order);
          // console.log(this.props.dataOrder);
          // Adding a feature to allow sorting across templates introduces
          // unneccessary bug and complexity, so removing for now and commenting.
          // for(var sub_key in this.state.children) {
          //   if (typeof this.state.children[sub_key] === 'object') {
          //     newState.push(this.state.children[sub_key]);
          //     design_order.push(this.state.children[sub_key].props.dataParent);
          //   }
          // }
          // console.log(design_order);
          // this.props.setDesingOrder(this.props.design_order);
          var dataOrder;
          if (!this.props.design_order.length) {
            dataOrder = this.props.design_order.replace(/\s/g, '').split(',');
          } else {
            dataOrder = this.props.design_order;
          }
          var dataStyleClass;

          // if (!this.props.dataStyleClass.length) {
          //   dataStyleClass = (this.props.dataStyleClass).replace(/\s/g,'').split(',');
          // } else {
          //   dataStyleClass = this.props.dataStyleClass;
          // }
          // console.log(this.state.children);
          var children_object = {};
          for (var sub_key in this.state.children) {
            if ((0, _typeof3.default)(this.state.children[sub_key]) === 'object') {
              children_object[this.state.children[sub_key].props.dataParent] = this.state.children[sub_key];
            }
          }
          design_order = [];
          // console.log(children_object);
          for (var key in dataOrder) {
            if (dataOrder[key]) {
              if (children_object[dataOrder[key]]) {
                newState.push(children_object[dataOrder[key]]);
                design_order.push(dataOrder[key]);
                // Delete key
                delete children_object[dataOrder[key]];
              }
            }
          }
          for (var child_key in children_object) {
            remainigState.push(children_object[child_key]);
            design_order.push(child_key);
          }

          this.props.setDesingOrder(design_order);
          // console.log(newState);
          // console.log(remainigState);

          // for (var key in dataOrder) {
          //   for(var sub_key in this.state.children) {
          //       if (this.state.children[sub_key].props.dataParent === dataOrder[key]) {
          //         newState.push(this.state.children[sub_key]);
          //
          //         console.log(this.state.children[sub_key].props.dataParent);
          //         break;
          //       } else {
          //         var already_in_remainingState = false;
          //         for (var rem_key in remainigState) {
          //           if (remainigState[rem_key] === this.state.children[sub_key]) {
          //             already_in_remainingState = true;
          //           }
          //         }
          //         if (!already_in_remainingState) {
          //           remainigState.push(this.state.children[sub_key]);
          //           // break;
          //         }
          //       }
          //
          //   }
          //   // if(!found) {
          //   //   remainigState.push(this.state.children[sub_key]);
          //   //   console.log(this.state.children[sub_key].props.dataParent);
          //   // }
          // }
          // console.log(newState);
          // console.log(remainigState);
        } else {
          // Checking if child is correct and adding it to DOM
          // Default templates would reach here.
          for (var sub_key in this.state.children) {
            if ((0, _typeof3.default)(this.state.children[sub_key]) === 'object') {
              newState.push(this.state.children[sub_key]);
              design_order.push(this.state.children[sub_key].props.dataParent);
            }
          }
          this.props.setDesingOrder(design_order);
        }
        if (remainigState.length) {
          newState = newState.concat(remainigState);
        }
        this.setState({ items: newState });
      } else {
        // Normal scenario this would add components of Databox


        var data_object;
        data_object = this.props.info_block[this.state.data_parent];
        this.setState({ items: data_object });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // ADD NEW SECTION: handles the case where a new object is added to the info_block
      // The else condition handles the case where an infoblock is added on an existing block type
      // (PR, ED, etc.) which had array length as 0
      if (this.props != nextProps) {

        if ((0, _keys2.default)(nextProps.info_block).length > (0, _keys2.default)(this.props.info_block).length) {
          //TODO: Check & revise this
          var new_blocks = (0, _keys2.default)(nextProps.info_block);
          var old_blocks = (0, _keys2.default)(this.props.info_block);

          var new_info_block_type;
          var diff = new_blocks.some(function (item) {
            if (old_blocks.indexOf(item) < 0) {
              new_info_block_type = item;
              return item;
            }
          });
          // console.log(this.props.child, nextProps.child, new_info_block_type)
          if (!nextProps.dataParent) {

            var newState = [];
            var design_order = [];
            var temp_new_info_block, temp_new_design_order;
            for (var sub_key in nextProps.child) {
              if ((0, _typeof3.default)(nextProps.child[sub_key]) === 'object') {
                newState.push(nextProps.child[sub_key]);
                design_order.push(nextProps.child[sub_key].props.dataParent);
              }
            }

            // console.log(newState, nextProps.child)
            if (design_order.includes(new_info_block_type)) {
              this.setState({ children: nextProps.child, items: newState });
              this.props.setDesingOrder(design_order);
            }

            // if (design_order.includes(new_info_block_type)) {
            //   // To add the section at the end of the designorder
            //   // console.log(design_order, design_order.length)
            //   // if (design_order[design_order.length - 1] != new_info_block_type){
            //   //   console.log(design_order)
            //   //   const old_position = design_order.indexOf(new_info_block_type);
            //   //   design_order.slice(old_position).push(new_info_block_type);
            //   // }
            //   this.setState({children: nextProps.child, items: newState});
            //   this.props.setDesingOrder(design_order);
            // }
          } else {

            if (new_info_block_type == nextProps.dataParent) {
              this.setState({ children: nextProps.child, data_parent: new_info_block_type, items: nextProps.info_block[new_info_block_type], dataOrder: nextProps.dataOrder });
            }
          }
        } else {

          if (!this.state.children && this.state.data_parent == nextProps.dataParent) {
            var data_object;
            data_object = nextProps.info_block[this.state.data_parent];
            this.setState({ items: data_object });
          }

          if (this.state.children) {
            var dataOrder = nextProps.design_order;
            var newState = [];
            var remainigState = [];
            var children_object = {};
            var children_count = 0;
            for (var sub_key in this.state.children) {
              if ((0, _typeof3.default)(this.state.children[sub_key]) === 'object') {
                children_object[this.state.children[sub_key].props.dataParent] = this.state.children[sub_key];
              }
            }

            var design_order = [];
            // console.log(this.state.children);
            // console.log(children_object);
            for (var key in dataOrder) {
              if (dataOrder[key]) {
                if (children_object[dataOrder[key]]) {
                  newState.push(children_object[dataOrder[key]]);
                  design_order.push(dataOrder[key]);
                  // Delete key
                  delete children_object[dataOrder[key]];
                }
              }
            }

            for (var child_key in children_object) {
              remainigState.push(children_object[child_key]);
              design_order.push(child_key);
            }
            if (remainigState.length) {
              newState = newState.concat(remainigState);
            }
            this.setState({ items: newState });
            this.props.setDesingOrder(design_order);
          }
        }
      }
    }
  }, {
    key: 'onAddBtnClick',
    value: function onAddBtnClick(index) {
      var new_id = Math.floor(Math.random() * 100000 + 1);
      // var object = JSON.parse(JSON.stringify(this.state.items[index]));
      // object['id'] = new_id;
      // var new_state = this.state.items.concat(
      //   object
      // );
      // new_state = arrayMove(new_state, new_state.length - 1, index + 1);
      // if(this.state.data_parent === 'professional'){
      //   // this.props.copyProfessional(index, new_id);
      // }
      // if(this.state.data_parent === 'miscellaneous'){
      //   // this.props.copyMiscellaneous(index, new_id);
      // }

      this.props.copy(index, new_id, this.state.data_parent);

      this.clearClass('section-menu-item-wrapper');
      // Removing direct state update as it is not right way to go.
      // Might cause race condition error, better would be to pass the  appropriate
      // props directly to the SortableContainer
      // this.setState({items: new_state});
      // Reverting to updating state here for now, will have to figure out Reducer
      // to throw event.
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Button clicked on - Add',
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
      (0, _jquery2.default)("html, body").animate({
        scrollTop: (0, _jquery2.default)('.' + this.state.data_parent + '-child-' + (this.state.items.length - 1).toString()).offset().top + 10 }, 1000);
    }
  }, {
    key: 'onDeleteBtnClick',
    value: function onDeleteBtnClick(index) {
      var confirm = window.confirm('Are you sure you want to delete this section from your Resume?\n If you proceed, you will not be able to recover the data in this section.');
      if (confirm) {
        // var state = this.state.items
        // state.splice(index, 1)
        // console.log(index);

        // if(this.state.data_parent === 'professional'){
        //   // this.props.deleteProfessional(index);
        // }
        // if(this.state.data_parent === 'miscellaneous'){
        //   // this.props.deleteMiscellaneous(index);
        // }
        // this.props.delete(index, this.state.data_parent)
        // this.props.deleteBlockProfessional(index);
        // TODO: This is a very bad hack, need to fix this and resolve this ASAP!!
        // this.props.sortProfessional(0, 0);
        // this.props.sortMiscellaneous(0, 0);
        // this.setState({items: state});

        this.props.delete(index, this.state.data_parent);

        this.clearClass('section-menu-item-wrapper');
        // this.props.sort(0, 0, this.state.data_parent);
        this.props.ReactGA.event({
          category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
          action: 'Button clicked on - Delete',
          label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
        });
      }
    }
  }, {
    key: 'moveDown',
    value: function moveDown(index) {
      if (index) {
        // this.setState({
        //  items: arrayMove(this.state.items, index, index - 1),
        // });
        this.props.sortDataOrder(index, index - 1);
        this.clearClass('section-menu-item-wrapper');
        this.props.ReactGA.event({
          category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
          action: 'Button clicked on - Move Down',
          label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
        });
      }
    }
  }, {
    key: 'moveUp',
    value: function moveUp(index) {
      if (this.state.items.length > index + 1) {
        // this.setState({
        //  items: arrayMove(this.state.items, index, index + 1),
        // });
        this.props.sortDataOrder(index, index + 1);
        this.clearClass('section-menu-item-wrapper');
      }
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Button clicked on - Move Up',
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.analysis_mode_on != this.props.analysis_mode_on) {
        this.setState({ section_analysis_visible: this.props.analysis_mode_on });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var headingClass = this.state.data_parent + '-heading ' + this.props.dataHeadingStyleClass;
      var headingMargin = {
        marginTop: this.props.inter_section_margin,
        marginBottom: this.props.inter_section_margin
      };
      var parentClass;
      if (this.state.items && this.state.items.length != 0) {
        if (this.state.children) {
          parentClass = 'sortableItemParent';
        } else {
          parentClass = sortableItemParent;
        }
        return _react2.default.createElement(
          'div',
          { className: parentClass, id: this.state.data_parent },
          this.state.section_analysis_visible && _react2.default.createElement(_components.SectionAnalysis, { data_parent: this.state.data_parent }),
          _react2.default.createElement(
            'div',
            { className: headingClass },
            this.props.heading
          ),
          _react2.default.createElement(SortableList, {
            axis: 'xy',
            items: this.state.items,
            onSortEnd: this.onSortEnd,
            useDragHandle: true,
            moveUp: this.moveUp.bind(this),
            moveDown: this.moveDown.bind(this),
            addClick: this.onAddBtnClick.bind(this),
            deleteClick: this.onDeleteBtnClick.bind(this),
            data_parent: this.state.data_parent,
            children: this.state.children,
            dataOrder: this.state.dataOrder,
            dataStyleClass: this.state.dataStyleClass,
            dataSectionStyleClass: this.state.dataSectionStyleClass,
            dataAspectRatio: this.props.dataAspectRatio,
            useWindowAsScrollContainer: true,
            dataBlockClass: this.props.dataBlockClass
          })
        );
      } else {
        return _react2.default.createElement('div', { className: parentClass });
      }
    }
  }]);
  return Sortable;
}(_react.Component)) || _class);
exports.default = Sortable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Sortable/Sortable.js
// module id = 1749
// module chunks = 0